import { Navigate, createFileRoute } from '@tanstack/react-router';
import { AuthPage } from '../components/pages/AuthPage/AuthPage';
import { useApiState } from '../contexts/ApiContext';

function AuthGuard() {
  const state = useApiState();
  switch (state) {
    case 'unauthenticated':
      return <AuthPage />;
    case 'authenticated':
      return <Navigate to="/account/home" replace />;
    default:
      return null;
  }
}

export const Route = createFileRoute('/auth')({
  component: AuthGuard,
  validateSearch: (search) => {
    if (search.signup) {
      return { signup: true };
    }
    return {};
  },
});
